import IsibuteDocumentComponent from "./IsibuteDocumentComponent";

class IsibuteDocumentParagraph extends IsibuteDocumentComponent {};

export default IsibuteDocumentParagraph;